import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as datepickerRange from '@elements/datepicker-range';
datepickerRange.init();

import * as asyncSlider from './scripts/async-slider';
asyncSlider.init();

import * as resetForm from './scripts/reset-form';
resetForm.init();

import * as oaMap from './scripts/oa-map';
oaMap.init();

import * as calculateRoute from './scripts/calculate-route';
calculateRoute.init();

import * as sharing from './scripts/sharing';
sharing.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as rangeSlider from '@elements/range-slider';

import {createApp} from 'vue';
import {initInScope} from '@elements/init-modules-in-scope';
onFind('.vue-initialize-module', function(element) {

    let vueApp = createApp({});
    const getModule = () => import(`./scripts/components/checkbox-dropdown.vue`);
    getModule()
        .then(function(moduleName) {
            vueApp.component('checkbox-dropdown', moduleName.default);
            vueApp.mount(element);
            initInScope(element);
        }).catch(function(evt) {
        console.error(evt);
    });
    rangeSlider.init();
});